<template>
  <component
    :is="href ? 'a' : 'span'"
    class="mobile-cta-btn"
    :href="href || null"
    :target="href ? '_blank' : null"
    :rel="href ? 'noopener noreferrer' : null"
    :aria-disabled="href ? null : 'true'"
  >
    <span class="mobile-cta-btn__label">{{ label }}</span>
    <svg
      class="mobile-cta-btn__chevron"
      viewBox="0 0 28 47"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M0 0 L16 23.5 L0 47 L12 47 L28 23.5 L12 0 Z" fill="currentColor" />
    </svg>
  </component>
</template>

<script>
/**
 * 移动端通用 CTA 按钮，PC 版见 views/pc/components/PcCtaButton.vue。
 *
 * 外形沿用首页巡演卡片的 list-item-btn（移动端为 .about-section__link-img，
 * 切图 index/card_btn_*.webp）：左上 / 右下大圆角的胶囊、右侧折线箭头、
 * 右下错位副色块。切图把文案烤死在图里，需要自定义文字时用本 CSS 还原版本。
 *
 * 触屏没有 hover，PC 版那套 clip-path 揭色在这里只会在按下瞬间闪一下，
 * 故只保留按下的缩放反馈。
 *
 * 注意：不能提到 views/mobile 之外——vue.config.js 的 postcss 按
 * `/views/mobile/` 路径才挂 px-to-viewport（viewportWidth 440），
 * 移出目录后 px 不再随屏缩放。
 */
export default {
  name: "MobileCtaButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    /** 为空时渲染为不可点击的 span（链接待运营填入） */
    href: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-cta-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 180px;
  max-width: 100%;
  height: 30px;
  padding: 0 30px;
  text-decoration: none;
  color: #191616;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.04em;
  -webkit-tap-highlight-color: transparent;
  transform-origin: center center;
  transition: transform 0.18s ease, filter 0.18s ease;

  /**
   * 两层同框叠色，靠 border-radius 差异露出错位块：
   * ::before 黄色垫层（右下角圆角很小）→ ::after 紫色主体（右下角大圆角，于是右下露出黄月牙）
   */
  &::before,
  &::after {
    content: "";
    position: absolute;
    inset: 0;
  }

  &::before {
    z-index: 0;
    background-color: #fff380;
    border-radius: 20px 0 4px 0;
  }

  &::after {
    z-index: 1;
    background-color: #d9a2ff;
    border-radius: 20px 0 24px 0;
  }

  /* 绝对定位的伪元素默认盖在行内文字之上，文字与箭头需抬到其上层 */
  &__label,
  &__chevron {
    position: relative;
    z-index: 2;
  }

  &__label {
    white-space: nowrap;
  }

  &__chevron {
    position: absolute;
    top: 50%;
    right: 18px;
    width: 7px;
    height: 12px;
    transform: translateY(-50%);
  }

  &:active {
    transform: scale(0.96);
    filter: brightness(0.9);
  }

  /* 链接未配置时不给点击反馈 */
  &[aria-disabled="true"]:active {
    transform: none;
    filter: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-cta-btn {
    transition: none;

    &:active {
      transform: none;
      filter: none;
    }
  }
}
</style>
